import React from 'react';
import { CloseEyeIcon, EyeIcon, LockIcon, SettingIcon, UserIcon, WebsiteLogo } from '../helper/Icons';
import { Link } from 'react-router-dom';
import giftSvg from './../../assets/images/svg/gift.svg';
import { languages } from '../helper/Helper';

function MobileSidebar({ menu, toggleMenu, showPassword, togglePass, toggleLangDropdown, getCurrentLanguageIcon, showLangDropdown, selectedLang, selectLanguage }) {
    return (
        <div className='bg-black'>
            <div className={`${menu ? 'menu-open' : 'menu-close'} w-100 position-absolute top-0 bg-black d-lg-none ease-in-out3ms px-3`}>
                <div className='d-flex flex-column align-items-center gap-3 w-100 my-3'>
                    <div className='d-flex justify-content-between w-100'>
                        <div className="logo">
                            <Link to="/" className="navbar-brand me-4"><WebsiteLogo /></Link>
                        </div>
                        <button onClick={toggleMenu} className='btn bg-cherrygradient px-2 py-0' aria-label="Close menu">
                            <i className="fa-solid fa-x close-btn-icon"></i>
                        </button>
                    </div>
                    <form>
                        <div className='d-flex flex-column gap-3'>
                            <div className='bg-cinder d-flex align-items-center gap-2 border-ebonyclay rounded-3 px-3 py-2'>
                                <UserIcon />
                                <input type="text" id='mob-username' placeholder='Username' className='bg-transparent border-0 outline-none w-100 text-marbleblue fs-14' autoComplete="off" />
                            </div>
                            <div className='bg-cinder d-flex align-items-center gap-2 border-ebonyclay rounded-3 px-3 py-2'>
                                <span className='w-100 max-w-15'><LockIcon /></span>
                                <input type={showPassword === true ? 'text' : 'password'} id='mobpassword' placeholder='Password' required className='bg-transparent border-0 outline-none w-100 text-marbleblue fs-14' autoComplete="off" />
                                <span className='w-100 max-w-20 cursor-pointer' onClick={togglePass}>
                                    {showPassword === true ? <CloseEyeIcon /> : <EyeIcon />}
                                </span>
                            </div>
                        </div>
                    </form>
                    <div className='d-flex flex-column align-items-center gap-2 w-100'>
                        <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                            <Link to={'/'} className='login ease-in-out3ms montserrat text-white fw-semibold leading-120 text-decoration-none bg-darkslategrey rounded-3 px-3 py-2'>Log in</Link >
                            <Link to={'/'} className='singup ms-1 montserrat text-white fw-semibold leading-120 text-decoration-none bg-darkslategrey rounded-3 position-relative bg-cherrygradient ease-in-out3ms px-3 py-2'>Sign Up <span className='position-absolute bottom-0'>
                                <img src={giftSvg} alt="Gift Img" />
                            </span></Link >
                        </div>
                        <div className='bg-darkslategrey position-relative d-flex align-items-center rounded-3 ms-4 p-2'>
                            <div className='border-riverbed border-0 border-end pe-2'>
                                <div className='d-flex align-items-center'>
                                    {getCurrentLanguageIcon()}
                                </div>
                            </div>
                            <div className='cursor-pointer ps-2' onClick={toggleLangDropdown}>
                                <SettingIcon />
                                {showLangDropdown && (
                                    <div className='position-absolute top-100 end-0 bg-darkslategrey rounded-3 py-1 mt-1 shadow-lg z-3' style={{ minWidth: '150px' }}>
                                        {languages.map((lang) => (
                                            <div
                                                key={lang.code}
                                                className={`px-3 py-2 cursor-pointer hover:bg-cinder ${selectedLang === lang.code ? 'bg-cinder' : ''}`}
                                                onClick={() => selectLanguage(lang.code)}
                                            >
                                                <div className='d-flex align-items-center gap-2'>
                                                    {lang.icon}
                                                    <span className='text-white fs-14'>{lang.name}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MobileSidebar;
